/**农化服务大联盟 */

/*主容器文件*/
const nhfwdlm_ = () =>
  import("../../../studio/sub_systems/nhfwdlm_systems/index");
/*首页*/
const nhfwdlm_index_ = () =>
  import("../../../studio/sub_systems/nhfwdlm_systems/index_page_main");

/**商品及服务 */
const nhfwdlm_index_spjfw = () =>
  import("../../../studio/sub_systems/nhfwdlm_systems/spjfw/index");

//产融云平台
const nfwdlm_index_crypt = () =>
  import("../../../studio/sub_systems/nhfwdlm_systems/crypt/index.vue");
const nfwdlm_index_event = () =>
  import(
    "../../../studio/sub_systems/nhfwdlm_systems/eventManagement/index.vue"
  );
const nfwdlm_index_goods = () =>
  import(
    "../../../studio/sub_systems/nhfwdlm_systems/goodsManagement/index.vue"
  );
const nfwdlm_index_zcxxgl = () =>
  import(
    "../../../studio/sub_systems/nhfwdlm_systems/yongyouBIP/zcxxgl/index.vue"
  );
const nfwdlm_index_zcbdgl = () =>
  import(
    "../../../studio/sub_systems/nhfwdlm_systems/yongyouBIP/zcbdgl/index.vue"
  );
const nfwdlm_index_zcbfgl = () =>
  import(
    "../../../studio/sub_systems/nhfwdlm_systems/yongyouBIP/zcbfgl/index.vue"
  );
const nfwdlm_index_zcyjgl = () =>
  import(
    "../../../studio/sub_systems/nhfwdlm_systems/yongyouBIP/zcyjgl/index.vue"
  );
export default [
  {
    path: "/nhfwdlm",
    name: "平台对接",
    redirect: "/nhfwdlm/index",
    component: nhfwdlm_,
    children: [
      {
        path: "/nhfwdlm/index",
        redirect: "/nhfwdlm/index/spjfw",
        name: "农化服务大联盟",
        component: nhfwdlm_index_,
        children: [
          {
            path: "/nhfwdlm/index/spjfw",
            name: "商品及服务",
            component: nhfwdlm_index_spjfw
          }
        ]
      },
      {
        path: "/crypt",
        redirect: "/nhfwdlm/index/crypt",
        name: "产云融平台",
        component: nhfwdlm_index_,
        children: [
          {
            path: "/nhfwdlm/index/crypt",
            name: "首页",
            component: nfwdlm_index_crypt
          },
          {
            path: "/nhfwdlm/index/eventManagement",
            name: "活动管理",
            component: nfwdlm_index_event
          },
          {
            path: "/nhfwdlm/index/goodsManagement",
            name: "商品管理",
            component: nfwdlm_index_goods
          }
        ]
      },
      {
        path: "/yongyouBIP",
        redirect: "/nhfwdlm/index/zcxxgl",
        name: "用友YonBIP",
        component: nhfwdlm_index_,
        children: [
          {
            path: "/nhfwdlm/index/zcxxgl",
            name: "资产信息管理",
            component: nfwdlm_index_zcxxgl
          },
          {
            path: "/nhfwdlm/index/zcbdgl",
            name: "资产变动管理",
            component: nfwdlm_index_zcbdgl
          },
          {
            path: "/nhfwdlm/index/zcbfgl",
            name: "资产报废管理",
            component: nfwdlm_index_zcbfgl
          },
          {
            path: "/nhfwdlm/index/zcyjgl",
            name: "资产移交管理",
            component: nfwdlm_index_zcyjgl
          }
        ]
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/nhfwdlm/nhfwdlm_system_page.js